<template>
	<div class="pulse">
		<div class="container">
			<div class="noinfo">
				<span>Данные об архиве</span>
				<span>Отсутствует информация</span>
			</div>
			<div id="chartContainer_archive"></div>
		</div>
		<div class="container">
			<div class="noinfo">
				<span>Реалтайм</span>
				<span>Отсутствует информация</span>
			</div>
			<div id="chartContainer_realtime"></div>
		</div>
	</div>
</template>
<script>
	import PulseGraph from "../script/pulse_graph";

	export default {
		name: "Archive",
		mounted() {

			new PulseGraph(
				"chartContainer_archive",
				"chartContainer_realtime",
				"wss://p0.tv.kvant-telecom.ru:8070"
			);
		}
	};
</script>
<style scoped lang="scss">
	.pulse {
		position: relative;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		margin: auto;
		align-content: flex-start;
		.container {
			position: relative;
			padding: 0;
			margin: 0.5rem;
			.noinfo {
				position: absolute;
				width: 45rem;
				height: 20rem;
				display: flex;
				flex-direction: column;
				justify-content: center;
				span {
					height: 30px;
					font-size: 1.2rem;
					text-align: center;
				}
			}
		}
		div {
			width: 45rem;
			height: 20rem;
			box-shadow: 0 0 5px #909090;
			background-color: rgba(184, 117, 209, 0.15);
		}
		
		div {
			width: 45rem;
			height: 20rem;
		}
		
		canvas {
			width: 45rem;
			height: 20rem;
			border-radius: 5px;
			opacity: 0.2;
		}
		
		#chartContainer_archive, #chartContainer_realtime {
			font-size: 12px;
			min-width: 45rem;
			min-height: 20rem;
		}
	}
	@media (min-width: 1200px) {
		.pulse {
			width: 98%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Archive.vue